<template>
  <div class="container-fluid" :class="[navBar ? 'expand-products' : 'closed-products']">

    <h1>Shop Powder Coating Colors</h1>

    <marketing-banner v-show="selectedCollectionCategory.collection_page_text === null" />

    <div id="main-content">

      <section id="products-and-pills">

        <filter-pills v-show="!activeSubCollections.length" />

        <div v-if="selectedCollectionCategory.collection_page_text !== null" class="collection-info">
          <h2>{{ selectedCollectionCategory.collection_page_title }}</h2>
          <p v-html="selectedCollectionCategory.collection_page_text"></p>
        </div>

        <div id="sub-categories" v-show="activeSubCollections.length">
          <div class="sub-category-card" v-for="(subCollections, index) in activeSubCollections" :key="index">
            <a :href="`/shop/powder-coating-colors?finishes=${subCollections.code}`">
              <div class="thumbnail">
                <img v-if="$root.$mq === '1199' || $root.$mq === 'desktop'" :src="subCollections.desktop_image_url"
                  :alt="$root.domainName + ' ' + subCollections.collection_page_title" />
                <img v-else-if="$root.$mq === '991' || $root.$mq === '767'" :src="subCollections.tablet_image_url"
                  :alt="$root.domainName + ' ' + subCollections.collection_page_title" />
                <img v-else-if="$root.$mq <= '600'" :src="subCollections.mobile_image_url"
                  :alt="$root.domainName + ' ' + subCollections.collection_page_title" />
              </div>
              <div class="label label-default" v-show="subCollections.collection_page_title">
                {{ subCollections.collection_page_title }}
              </div>
            </a>
          </div>
        </div>

        <products v-if="!hasSelectedParentCollection || activeSubCollections.length === 0"
          @add-swatch-to-cart="addSwatchToCart" />

      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Products from './products/Products';
import FilterPills from "./sidebar/filters/FilterPills";
import MarketingBanner from './MarketingBanner.vue'

export default {
  name: 'ShopMainContent',

  components: {
    Products,
    FilterPills,
    MarketingBanner
  },

  computed: {
    ...mapGetters([
      'selectedCollectionCategory',
      'navBar'
    ]),

    hasSelectedParentCollection() {
      const parentCollection = this.selectedCollectionCategory.parent_category_refs;

      if (parentCollection.length && parentCollection[0].name === 'Collections') {
        return true;
      }

      return false;
    },

    activeSubCollections() {
      const parentCategory = this.selectedCollectionCategory.parent_category_refs;
      const subCategory = this.selectedCollectionCategory.sub_categories;

      if (parentCategory.length) {
        return parentCategory[0].name === 'Collections' ? subCategory.filter((active) => {
          return active.enabled;
        }) : [];
      }

      return [];
    }
  },

  methods: {
    addSwatchToCart(swatch) {
      this.$emit('add-swatch-to-cart', swatch);
    }
  }
}
</script>

<style lang="scss">
.expand-products {
  margin-left: 360px;
  transition: margin-left 0.1s;
}

.closed-products {
  transition: 0.1s;
}

#main-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: 25px;

  #sub-categories {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: calc(1.6vmin);
    width: 100%;
    margin-bottom: 25px;

    .sub-category-card {
      padding-top: 100%;
      box-sizing: border-box;
      position: relative;
      border-radius: 6px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      max-height: 300px;
      min-width: 300px;

      .label {
        font-size: 1.5rem;
        margin: 0%;
        text-overflow: ellipsis;
        overflow: hidden;
        position: absolute;
        transform: translate(5%, -135%);
        max-width: calc(300px - 1em);
        width: 90%;
        padding: 8%;
        border-radius: 6px;
        background-color: #fff;
        color: #000;
        font-size: 20px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-transform: uppercase;
        font-size: x-large;
      }

      .thumbnail {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin-bottom: 0;
        border-radius: 6px;

        img {
          border-radius: 6px 6px 0 0;
          height: 100%;
          width: 100%;
          object-fit: contain;
          -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
          transition: opacity 0.35s, transform 0.35s;
          -webkit-transform: scale(1);
          transform: scale(1);
        }
      }

      &:hover {
        opacity: 0.5;
      }
    }

    @media (max-width: 1024px) {
      grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
    }

    @media (max-width: 479px) {
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }

  #products-and-pills {
    display: flex;
    flex-grow: 1;
    flex-direction: column;

    .collection-info {
      margin-bottom: 25px;
      background-color: #FFF;
      padding: 15px;
      border-radius: 6px;
      display: inline-block;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      width: 100%;
      color: #393939;
    }

    @media (max-width: 768px) {
      padding: 0;
    }
  }
}
</style>
